import React from "react";

export const CheckIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9999 0C8.97202 0 0 8.97181 0 19.9999C0 31.028 8.97202 40 19.9999 40C31.0278 40 39.9998 31.028 39.9998 19.9999C39.9998 8.97181 31.028 0 19.9999 0ZM31.4842 16.6217L18.9193 29.1867C18.385 29.7209 17.6748 30.015 16.9193 30.015C16.1639 30.015 15.4537 29.7209 14.9194 29.1867L8.5156 22.7828C7.98134 22.2486 7.68708 21.5384 7.68708 20.7829C7.68708 20.0272 7.98134 19.317 8.5156 18.7828C9.04965 18.2485 9.75984 17.9543 10.5155 17.9543C11.271 17.9543 11.9814 18.2485 12.5155 18.783L16.9191 23.1865L27.4839 12.6217C28.0182 12.0874 28.7284 11.7934 29.4838 11.7934C30.2393 11.7934 30.9495 12.0874 31.4838 12.6217C32.5869 13.7248 32.5869 15.519 31.4842 16.6217Z"
        fill="#554DF1"
      />
    </svg>
  );
};
